/* global axios */

import ApiClient from './ApiClient';

class SallaAPI extends ApiClient {
  constructor() {
    super('salla', { accountScoped: true });
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  authUrl() {
    return axios.get(`${this.url}/auth_url`);
  }

  products(params = {}) {
    return axios.get(`${this.url}/products`, { params });
  }

  customers(params = {}) {
    return axios.get(`${this.url}/customers`, { params });
  }

  orders(params = {}) {
    return axios.get(`${this.url}/orders`, { params });
  }

  abandonedCarts(params = {}) {
    return axios.get(`${this.url}/abandoned_carts`, { params });
  }

  webhookEvents(params = {}) {
    return axios.get(`${this.url}/webhook_events`, { params });
  }

  registerWebhooks(payload) {
    return axios.post(`${this.url}/register_webhooks`, payload);
  }

  unregisterWebhooks() {
    return axios.delete(`${this.url}/unregister_webhooks`);
  }

  updateSettings(payload) {
    return axios.patch(`${this.url}/settings`, payload);
  }

  importCustomer(customer) {
    return axios.post(`${this.url}/import_customer`, { customer });
  }

  createConversation(payload) {
    return axios.post(`${this.url}/create_conversation`, payload);
  }

  disconnect() {
    return axios.delete(`${this.url}/disconnect`);
  }
}

export default new SallaAPI();
